import { ApiRequestContextData } from "@utils/api-config/types";

export function getDefaultRequestContext() {
	const user = App.state.rootStore.userAuthStore.user;
	const token = App.state.rootStore.userAuthStore.token;

	if (!user || !token) {
		const requestMetaData: ApiRequestContextData = {
			agencyId: null,
			agencyKey: WEBPACK_DEFAULT_AGENCY_KEY,
			authToken: null,
			shopId: WEBPACK_DEFAULT_SHOP_ID,
			userId: null,
		};
		return requestMetaData;
	}

	const requestMetaData: ApiRequestContextData = {
		agencyId: user.agencyId,
		agencyKey: user.agencyKey,
		authToken: token.token,
		shopId: user.shopId,
		userId: user.id,
	};

	return requestMetaData;
}
